import { render, staticRenderFns } from "./PasteDetail.vue?vue&type=template&id=acdc4e5c&scoped=true&"
import script from "./PasteDetail.vue?vue&type=script&lang=js&"
export * from "./PasteDetail.vue?vue&type=script&lang=js&"
import style0 from "./PasteDetail.vue?vue&type=style&index=0&id=acdc4e5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdc4e5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
